export enum PermissionEnum {
  ScreenAdminRead = 1,
  ScreenAdminWrite = 2,
  ScreenInternalDashboardRead = 3,
  ScreenInternalDashboardWrite = 4,
  ScreenSurveyDetailRead = 5,
  ScreenSurveyDetailWrite = 6,
  ScreenBenchmarkRead = 7,
  ScreenBenchmarkWrite = 8,
  ScreenSurveyEditColleagueRead = 9,
  ScreenSurveyEditColleagueWrite = 10,
  ScreenConfigureQuestionnairesRead = 11,
  ScreenConfigureQuestionnairesWrite = 12,
  ScreenClientDashboardRead = 13,
  ScreenClientDashboardWrite = 14,
  ScreenClientAddColleagueRead = 15,
  ScreenClientAddColleagueWrite = 16,
  ScreenClientEditColleagueRead = 17,
  ScreenClientEditColleagueWrite = 18,
  ScreenGenerateReportRead = 19,
  ScreenGenerateReportWrite = 20,
  ScreenViewResponsesRead = 21,
  ScreenViewResponsesWrite = 22,
  ScreenViewResponsesAddButton = 23,
  ScreenViewResponsesEditButton = 24,
  ScreenViewResponsesDeleteButton = 25,
  ScreenContactAddEditRead = 26,
  ScreenContactAddEditWrite = 27,
  ScreenDealAddEditRead = 28,
  ScreenDealAddEditWrite = 29,
  ScreenCompanyAddEditRead = 30,
  ScreenCompanyAddEditWrite = 31,
  ScreenViewDealList = 32,
  ScreenViewDealDetailPage = 33,
  ScreenAuditLogRead = 34,
  ScreenUserAdminRead = 35,
  ScreenUserAdminWrite = 36,
  ScreenUserDeviceRead = 37,
  ScreenUserDeviceWrite = 38,
  ScreenSurveyProductRead = 39,
  ScreenSurveyProductWrite = 40,
  ScreenImpersonationAuditLogRead = 41,
  ScreenBrandingRead = 42,
  ScreenBrandingWrite = 43,
  ScreenReportTemplateRead = 44,
  ScreenReportTemplateWrite = 45,
  ScreenReportTemplateArchive = 46,
}
